import * as React from 'react';
import {MiniGraph, MetricValue} from './components';

export interface ShopMetricProps {
  asterisk?: boolean;
  currency: boolean;
  monthByMonth: any;
  qualifier?: string;
  showQualifier?: boolean;
  value: number;
}

export function ShopMetric(props: ShopMetricProps) {
  const {
    asterisk,
    currency,
    monthByMonth,
    qualifier,
    value,
  } = props;

  return (
    <div className="shop-tile__metric">
      {qualifier ? (
        <div className="shop-tile__qualifier">
          {qualifier}
          {
            currency &&
            <span className="qualifier-unit"> (USD)</span>
          }
          {
            asterisk &&
            <span className="text-grey-light">*</span>
          }
        </div>
      ) : null}
      <div className={`shop-tile__data ${monthByMonth ? 'shop-tile__data--has-graph' : ''}`}>
        <MiniGraph
          currency={currency}
          monthByMonth={monthByMonth}
        />

        <MetricValue
          currency={currency}
          value={value}
        />
      </div>
    </div>
  );
}

export default ShopMetric;
